/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { PaymentSteps } from "../../../components";
import { Layout, Typography, Form } from "antd";
import FaceComparison from "./FaceComparison";
import PersonalInfo from "./PersonalInfo";
import ContactInfo from "./ContactInfo";
import OthersInfo from "./OthersInfo";
import VerificationInfo from "./VerificationInfo";
import PaymentDetail from "./PaymentDetail";
import PaymentComplete from "./PaymentComplete";
import PaymentProcessing from "./PaymentProcessing";
import ApplicationForm from "./ApplicationForm/ApplicationForm";
import { useTranslation } from "react-i18next";

import visaRequestServices from "../../../api/services/visaRequestServices";
import { useLocation } from "react-router";
import PolicyConfirmModal from "../../../components/common/Modal/PolicyConfirmModal";

const { Content } = Layout;
const { Title } = Typography;

const Payment = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [currentStep, setCurrentStep] = useState<number>(1);

  // Payment State
  const [isLoading, setIsLoading] = useState(false);
  const [isComplete, setIsComplete] = useState(false);
  const [paymentData, setPaymentData] = useState<any>(null);

  // Form Data
  const [form] = Form.useForm<IVisaRequestFormData>();

  // OCR Data
  const [passportData, setPassportData] = useState<any>("");
  const [faceMatchingData, setFaceMatchingData] = useState<any>("");
  const [passportImage, setPassportImage] = useState<any>(null);
  const [selfieImage, setSelfieImage] = useState<any>(null);

  // Verification Code State
  const [verificationCode, setVerificationCode] = useState("");

  // Payment Details
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("Paypal");
  const [paymentInfo, setPaymentInfo] = useState<IPaymentInfo>({
    request_id: 0,
    voucher_code: "",
    currency_code: "USD",
  });
  const [openAgreePolicyModal, setOpenAgreePolicyModal] = useState(true);
  const [agreePolicy, setAgreePolicy] = useState(false);

  // Handle Submit Visa Request
  const handleDateOfEntry = (formData: FormData) => {
    formData.append(
      "intended_date_of_entry",
      form.getFieldValue("intended_date_of_entry").format("YYYY-MM-DD")
    );

    const visaType = location.state?.typeVisa;
    if (form.getFieldValue("to_date")) {
      const startDate = form
        .getFieldValue("intended_date_of_entry")
        .format("YYYY-MM-DD");
      const inputDate = form.getFieldValue("to_date").format("YYYY-MM-DD");

      const date1 = new Date(startDate);
      const date2 = new Date(inputDate);

      const diffTime = Math.abs(date2.getTime() - date1.getTime());
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      formData.append("intended_length_of_stay", diffDays.toString());
    } else {
      let lengthOfStay = 0;

      if (visaType.includes("OneMonth")) {
        lengthOfStay = 30;
      } else if (visaType.includes("ThreeMonth")) {
        lengthOfStay = 90;
      }

      formData.append("intended_length_of_stay", lengthOfStay.toString());
    }
  };
  const handleFormSubmit = async () => {
    setIsLoading(true);
    const formData = new FormData();

    formData.append("processing_type", form.getFieldValue("processing_type"));
    formData.append("evisa_entry_type", form.getFieldValue("evisa_entry_type"));

    // Upload images
    if (selfieImage)
      formData.append(
        "self_image",
        selfieImage,
        `selfie_${Date.now()}.${selfieImage.type.split("/")[1]}`
      );
    if (passportImage)
      formData.append(
        "passport_image",
        passportImage,
        `passport_${Date.now()}.${passportImage.type.split("/")[1]}`
      );

    // Personal Info
    formData.append("surname", form.getFieldValue("surname") || "");
    formData.append(
      "middle_and_given_name",
      form.getFieldValue("middle_and_given_name")
    );
    formData.append(
      "date_of_birth",
      form.getFieldValue("date_of_birth").format("YYYY-MM-DD")
    );
    formData.append("gender", form.getFieldValue("gender"));
    formData.append("nationality", form.getFieldValue("nationality"));
    formData.append("id_card", form.getFieldValue("id_card") || "");
    formData.append("email", form.getFieldValue("email"));
    formData.append(
      "create_account_by_email",
      form.getFieldValue("create_account_by_email") ? "True" : "False"
    );
    formData.append("religion", form.getFieldValue("religion") || "No");
    formData.append("place_of_birth", form.getFieldValue("place_of_birth"));

    // Passport Info
    formData.append(
      "request_passport_number",
      form.getFieldValue("request_passport_number")
    );
    formData.append(
      "passport_place_of_issue",
      form.getFieldValue("passport_place_of_issue") || ""
    );
    formData.append("passport_type", form.getFieldValue("passport_type"));
    formData.append(
      "date_of_issue",
      form.getFieldValue("date_of_issue").format("YYYY-MM-DD")
    );
    formData.append(
      "passport_expiry_date",
      form.getFieldValue("passport_expiry_date").format("YYYY-MM-DD")
    );

    // Contact Info
    formData.append(
      "permanent_residental_address",
      form.getFieldValue("permanent_residental_address") || ""
    );
    formData.append(
      "contact_address",
      form.getFieldValue("permanent_residental_address") || ""
    );
    formData.append(
      "telephone_number",
      form.getFieldValue("telephone_number") || ""
    );
    formData.append(
      "emergency_fullname",
      form.getFieldValue("emergency_fullname") || ""
    );
    formData.append(
      "emergency_current_residental_address",
      form.getFieldValue("emergency_current_residental_address") || ""
    );
    formData.append(
      "emergency_telephone_number",
      form.getFieldValue("emergency_telephone_number") || ""
    );
    formData.append(
      "emergency_relationship",
      form.getFieldValue("emergency_relationship") || ""
    );

    // Occupation Info
    formData.append("occupation", form.getFieldValue("occupation") || "Others");
    formData.append(
      "occupation_info",
      form.getFieldValue("occupation_info") || ""
    );
    formData.append("company_name", form.getFieldValue("company_name") || "");
    formData.append(
      "position_of_study",
      form.getFieldValue("position_of_study") || ""
    );
    formData.append(
      "company_address",
      form.getFieldValue("company_address") || ""
    );
    formData.append(
      "company_phone_number",
      form.getFieldValue("company_phone_number") || ""
    );

    // Trip Info
    formData.append("entry_purpose", form.getFieldValue("entry_purpose"));

    handleDateOfEntry(formData);

    formData.append(
      "vietnam_phone_number",
      form.getFieldValue("vietnam_phone_number") || ""
    );
    formData.append(
      "vietnam_residental_address",
      // form.getFieldValue("vietnam_residental_address")
      form.getFieldValue("ward") +
        ", " +
        form.getFieldValue("district") +
        ", " +
        form.getFieldValue("province")
    );
    formData.append("province", form.getFieldValue("province"));
    formData.append("district", form.getFieldValue("district"));
    formData.append("ward", form.getFieldValue("ward"));
    formData.append(
      "intended_entry_border_gate",
      form.getFieldValue("intended_entry_border_gate")
    );
    formData.append(
      "intended_exit_border_gate",
      form.getFieldValue("intended_exit_border_gate")
    );

    // Funding and Insurance Info
    formData.append(
      "intended_expenses",
      form.getFieldValue("intended_expenses") || 0
    );
    formData.append(
      "insurance_specify",
      form.getFieldValue("insurance_specify") || ""
    );
    formData.append(
      "trip_expenses_cover_by",
      form.getFieldValue("trip_expenses_cover_by") || "Personal"
    );
    formData.append(
      "expenses_payment_method",
      form.getFieldValue("expenses_payment_method") || "Cash"
    );
    formData.append(
      "expenses_company",
      form.getFieldValue("expenses_company") || ""
    );
    formData.append(
      "expenses_company_address",
      form.getFieldValue("expenses_company_address") || ""
    );
    formData.append(
      "expenses_company_telephone_number",
      form.getFieldValue("expenses_company_telephone_number") || ""
    );

    // Additional Table Info
    // const otherPassportsData = form.getFieldValue("other_passports");
    // formData.append(
    //   "other_passports",
    //   otherPassportsData.length > 0 ? JSON.stringify(otherPassportsData) : ""
    // );

    // const otherNationalities = form
    //   .getFieldValue("other_nationalities")
    //   .map((item: any) => {
    //     return item.country_name;
    //   });
    // formData.append(
    //   "other_nationalities",
    //   otherNationalities.length > 0 ? JSON.stringify(otherNationalities) : ""
    // );

    // const lawsViolationData = form.getFieldValue("laws_violation");
    // formData.append(
    //   "laws_violation",
    //   lawsViolationData.length > 0 ? JSON.stringify(lawsViolationData) : ""
    // );

    // const validPassportsData = form.getFieldValue("other_valid_passports");
    // formData.append(
    //   "other_valid_passports",
    //   validPassportsData.length > 0 ? JSON.stringify(validPassportsData) : ""
    // );

    // const contactPlans = form.getFieldValue("contact_plans");
    // formData.append(
    //   "contact_plans",
    //   contactPlans.length > 0 ? JSON.stringify(contactPlans) : ""
    // );

    // const tripLastYearData = form.getFieldValue("trips_in_the_last_one_year");
    // formData.append(
    //   "trips_in_the_last_one_year",
    //   tripLastYearData.length > 0 ? JSON.stringify(tripLastYearData) : ""
    // );

    // const relativesData = form.getFieldValue("relatives_in_vietnam");
    // formData.append(
    //   "relatives_in_vietnam",
    //   relativesData.length > 0 ? JSON.stringify(relativesData) : ""
    // );

    await visaRequestServices
      .createVisaRequest(formData)
      .then((response) => {
        console.log("Create Visa Request response:", response);

        if (response.data) {
          setPaymentInfo({
            ...paymentInfo,
            request_id: response.data.id,
          });

          // setIsLoading(false);
          // notification.success({
          //   message: "Success",
          //   description: "Create Visa Request Successfully",
          // });
          // form.resetFields();
          // setCurrentStep(3);
        }
      })
      .catch((error) => {
        console.log("Create Visa Request error:", error);
        // notification.error({
        //   message: "Error",
        //   description: "Failed to create visa request",
        // });
        setIsLoading(false);
      });
  };

  // Render Steps Content
  const steps = [
    {
      number: 1,
      title: t("registration_form.step1"),
    },
    {
      number: 2,
      title: t("registration_form.step2"),
    },
    {
      number: 3,
      title: t("registration_form.step3"),
    },
    {
      number: 4,
      title: "Payment processing",
    },
  ];
  const handleEditClick = (field: string) => {
    // console.log("field", field);
    setCurrentStep(1); // Go back to Step 1

    setTimeout(() => {
      requestAnimationFrame(() => {
        const element = document.querySelector(
          `[id="${field}"]`
        ) as HTMLElement;
        // console.log("Found element:", element);

        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "center" });
          element.focus();
        } else {
          console.log("Element not found even after delay.");
        }
      });
    }, 1000); // 1000ms delay to ensure rendering is done
  };

  const renderContent = () => {
    if (isComplete) {
      return <PaymentComplete paymentData={paymentData} />;
    }

    const faceMatchCode: string = (faceMatchingData as any)?.match ?? "";
    const matchPercentageValue: number = (() => {
      const raw = (faceMatchingData as any)?.matching;
      if (raw === null || raw === undefined) return 0;
      const sliced = String(raw).substring(0, 5);
      const parsed = Number.parseFloat(sliced);
      return Number.isFinite(parsed) ? parsed : 0;
    })();

    switch (currentStep) {
      case 1:
        return (
          <ApplicationForm
            form={form}
            setCurrentStep={setCurrentStep}
            passportImage={passportImage}
            setPassportImage={setPassportImage}
            selfieImage={selfieImage}
            setSelfieImage={setSelfieImage}
            passportData={passportData}
            faceMatchingData={faceMatchingData}
            setPassportData={setPassportData}
            setFaceMatchingData={setFaceMatchingData}
          />
        );
      case 2:
        return (
          <>
            <Title level={2}>
              1. {t("registration_form.review_profile.section1")}
            </Title>
            <FaceComparison
              form={form}
              matchPercentage={matchPercentageValue}
              imageQuality={
                faceMatchCode === "0" || faceMatchCode === "1" ? "Pass" : "Fail"
              }
              t={t}
              setPassportData={setPassportData}
              setFaceMatchingData={setFaceMatchingData}
              passportImage={passportImage}
              setPassportImage={setPassportImage}
              selfieImage={selfieImage}
              setSelfieImage={setSelfieImage}
            />

            <Title level={2} className="mt-12">
              2. {t("registration_form.review_profile.section2")}
            </Title>
            <PersonalInfo form={form} handleEditClick={handleEditClick} />

            <Title level={2} className="mt-12">
              3. {t("registration_form.review_profile.section3")}
            </Title>
            <ContactInfo form={form} handleEditClick={handleEditClick} />

            <Title level={2} className="mt-12">
              4. {t("registration_form.review_profile.section4")}
            </Title>
            <OthersInfo form={form} handleEditClick={handleEditClick} />

            <Title level={2} className="mt-12">
              5. {t("registration_form.review_profile.section5")}
            </Title>
            <VerificationInfo
              isLoading={isLoading}
              verificationCode={verificationCode}
              setVerificationCode={setVerificationCode}
              setCurrentStep={setCurrentStep}
              handleFormSubmit={handleFormSubmit}
              imageMatch={faceMatchCode}
            />
          </>
        );
      case 3:
        return (
          <>
            {/* <Title level={2}>{t("payment_details.title")}</Title> */}
            <PolicyConfirmModal
              isOpen={openAgreePolicyModal}
              onOk={() => {
                setAgreePolicy(true);
                setOpenAgreePolicyModal(false);
              }}
              onClose={() => {
                setAgreePolicy(false);
              }}
            />
            <PaymentDetail
              form={form}
              agreePolicy={agreePolicy}
              setAgreePolicy={setAgreePolicy}
              selectedPaymentMethod={selectedPaymentMethod}
              setSelectedPaymentMethod={setSelectedPaymentMethod}
              paymentInfo={paymentInfo}
              setPaymentInfo={setPaymentInfo}
              setIsComplete={setIsComplete}
              setPaymentData={setPaymentData}
              handleFormSubmit={handleFormSubmit}
            />
            <div className="flex w-full justify-center items-center">
              <div className="max-w-[400px] flex gap-4 mt-8 w-full justify-center items-center">
                <button
                  className="flex-1 py-4 px-6 border-2 font-bold border-primary-blue rounded-3xl text-primary-blue hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                  onClick={() => setCurrentStep(2)}
                >
                  {t("registration_form.back")}
                </button>

                {/* {selectedPaymentMethod === "Paypal" ? (
                  <PaypalButton
                    agreePolicy={agreePolicy}
                    setIsComplete={setIsComplete}
                    setPaymentData={setPaymentData}
                    paymentInfo={paymentInfo}
                    handleFormSubmit={handleFormSubmit}
                  />
                ) : (
                  <button
                    className={`flex-1 py-4 px-6 border font-bold border-transparent rounded-3xl text-primary-blue bg-primary-lightyellow duration-200 ${
                      !agreePolicy
                        ? "opacity-50 cursor-not-allowed"
                        : "hover:bg-primary-yellow"
                    }`}
                    disabled={!agreePolicy}
                  >
                    {t("registration_form.continue")}
                  </button>
                )} */}
              </div>
            </div>

            {/* Referral Code Section - Add your referral code component here if needed */}

            {/* Square Payment Methods - Only show if policy is agreed */}
            {agreePolicy && <div className="mt-4 flex flex-col gap-4"></div>}
          </>
        );
      case 4:
        return (
          <>
            <Title level={2}>{t("select_payment_option.title")}</Title>
            <PaymentProcessing />
            <div className="flex w-full justify-center items-center">
              <div className="max-w-[400px] flex gap-4 mt-8 w-full justify-center items-center">
                <button className="flex-1 py-4 px-6 border-2 font-bold border-primary-blue rounded-3xl text-primary-blue hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                  {t("registration_form.cancel")}
                </button>
                {/* <button
                  className="flex-1 py-4 px-6 border font-bold border-transparent rounded-3xl text-primary-blue bg-primary-lightyellow hover:bg-primary-yellow duration-200"
                  onClick={handleContinue}
                >
                  {t("registration_form.continue")}
                </button> */}
                {/* <PaypalButton
                  setIsComplete={setIsComplete}
                  setPaymentData={setPaymentData}
                /> */}
              </div>
            </div>
          </>
        );

      default:
        return null;
    }
  };

  // const handleContinue = () => {
  //   if (currentStep === 4) {
  //     setIsComplete(true);
  //   } else {
  //     setCurrentStep((prev) => Math.min(prev + 1, steps.length));
  //   }
  // };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentStep]);

  useEffect(() => {
    if (location.state) {
      form.setFieldValue("processing_type", location.state.processingTime);
      form.setFieldValue("evisa_entry_type", location.state.typeVisa);
    }
  }, [location]);

  return (
    <div className="flex flex-col items-center justify-center">
      <div className="w-full">
        <div
          className="w-full py-8 px-4 text-center text-white"
          style={{
            background: "linear-gradient(to bottom, #F00D0D, #994F4F)",
          }}
        >
          <h1 className="text-2xl md:text-3xl font-semibold mb-2">
            {t("registration_form.title")}
          </h1>
          <p className="text-sm md:text-base">
            {t("registration_form.description")}
          </p>
        </div>
        <div className="w-full">
          <PaymentSteps steps={steps} currentStep={currentStep} />
          <Layout className="w-full bg-white">
            <Content className="p-6 flex justify-center items-center">
              <div className="w-full max-w-outer space-y-6">
                {renderContent()}
              </div>
            </Content>
          </Layout>
        </div>
      </div>
    </div>
  );
};

export default Payment;
